<template>
  <div class="message" :class="cls">
    <div class="message-width" v-if="message.text !== 'Let\'s go'">
      <img class="msg-avatar" v-if="message.sender === 'bot'" :src="message.avatar || (theme && theme.avatar) || '/assets/img/mascotte-cadeau.svg'" alt="Dreambuddy">
      <div class="msg-text" v-html="removeEmojiIE(message.text)" @click="rethink"></div>
    </div>
    <div class="products" v-if="message.products">
      <div class="product-carousel" ref="productCarousel" @scroll.passive="onscroll('product')" v-dragscroll.x>
        <div class="slide slide-push"></div>
        <div v-for="p in message.products" :key="p.product" class="slide slide--product" :data-tms-product-id="p.product">
          <product :product="p" @click-product="$root.showProduct(p, message.products)" @open-link="$root.openProductLink(p, message.products)" @load-more="$root.moreLikeThis(p, message.products)" />
        </div>
        <div class="slide">
          <quick :r="more" @click="sendQuick(more)" big />
        </div>
        <div class="slide slide-push"></div>
      </div>
      <button ref="prodLeft" v-if="!touchStarted" class="carousel-scroll carousel-scroll-prev hidden" @click="scrollBy(-1)"><icon name="chevron-left" fill="white" /></button>
      <button ref="prodRight" v-if="!touchStarted" class="carousel-scroll carousel-scroll-next" @click="scrollBy(1)"><icon name="chevron-right" fill="white" /></button>
    </div>
    <div class="categories" v-if="message.categories">
      <div class="category-carousel" ref="categoryCarousel" @scroll.passive="onscroll('category')" v-dragscroll.x>
        <div v-for="p in message.categories" :key="p.id" class="slide slide--category">
          <Category :category="p" v-model="message.categorySelection" @input="redo('categories')" />
        </div>
      </div>
      <button ref="catLeft" v-if="!touchStarted" class="carousel-scroll-categories carousel-scroll-prev hidden" @click="scrollByCategories(-1)"><icon name="chevron-left" fill="white" /></button>
      <button ref="catRight" v-if="!touchStarted" class="carousel-scroll-categories carousel-scroll-next" @click="scrollByCategories(1)"><icon name="chevron-right" fill="white" /></button>
    </div>
    <div class="message-width" v-if="message.buttons">
      <MyButton v-for="(b, index) in message.buttons" :key="index" :href="b.url" style="padding-left:1em;padding-right:1em">{{b.title}}</MyButton>
    </div>
    <div class="message-width" v-if="message.component === 'choices'">
      <Choices />
    </div>
    <div class="message-width" v-if="focus || (message.input && message.input.type === 'slider')">
      <div class="msg-input" v-if="message.input">
        <MessageInput :input="message.input" :next="message.next" :focus="focus" />
      </div>
      <div class="replies" :class="{ 'replies-scroll': message.quick_replies.length < 3 }" v-if="focus && message.quick_replies && !message.input" :style="{ textAlign: message.quick_replies.length > 2 ? 'left' : 'center' }">
        <quick v-for="(r, index) in quick_replies" :r="r" :key="index" @click="sendQuick(r)" />
      </div>
    </div>
  </div>
</template>

<script>
import Quick from './Quick.vue'
import MyButton from './MyButton.vue'
import { dragscroll } from '../dragscroll/main.js'

import { chat } from '../chat.js'
import { theme } from '../themes.js'
import { removeEmoji } from '../util.js'

const isIE = window.navigator.appVersion.indexOf('Trident/') > -1

export default {
  directives: {
    dragscroll
  },
  props: {
    message: null,
    focus: Boolean
  },
  components: {
    Category: () => import('./Category.vue' /* webpackChunkName: "1" */),
    MessageInput: () => import('./MessageInput.vue' /* webpackChunkName: "1" */),
    Choices: () => import('./Choices.vue' /* webpackChunkName: "1" */),
    MyButton,
    Product: () => import('./Product.vue' /* webpackChunkName: "1" */),
    Quick
  },
  data: () => ({
    theme
  }),
  computed: {
    cls() {
      return {
        focus: this.focus,
        rethinkable: this.rethinkable,
        'with-quicks': this.focus && this.message.quick_replies,
        'msg-by-you': this.message.sender !== 'bot',
        'msg-by-bot': this.message.sender === 'bot'
      }
    },
    more () {
      return {
        title: this.$root.__('more'),
        next: 'suggestions',
        icon: 'plus',
        fill: '#005ba9'
      }
    },
    quick_replies () {
      if (this.message.categorySelection && !this.message.categorySelection.length) {
        return [{
          title: this.$root.__('surprise me'),
          next: 'after_categories',
          icon: 'present',
          color: '#CC5194'
        },
        {
          title: this.$root.__('edit choices'),
          next: 'choices',
          icon: 'pencil',
          color: '#31aee9',
          data: {
            moreIds: '',
            seen: '',
          },
        },
      ]
      }
      return this.message.quick_replies
    },
    rethinkable () {
      return !this.focus && this.message.sender !== 'bot' && this.message.data
    },
    touchStarted () {
      return window.touchStarted
    }
  },
  methods: {
    removeEmojiIE (str) {
      return isIE ? removeEmoji(str) : str
    },
    redo (next) {
      if (!this.focus) {
        chat.send({
          data: {},
          next
        })
      }
    },
    rethink () {
      if (this.rethinkable) {
        const [next] = Object.keys(this.message.data)
        next && chat.send({
          data: {},
          next
        })
      }
    },
    scrollBy (dir) {
      const inner = window.innerWidth
      const width = inner > 999 ? Math.round(inner * .5) : 250
      this.$refs.productCarousel.scrollBy({ top: 0, left: dir * width, behavior: 'smooth' })
    },
    scrollByCategories (dir) {
      this.$refs.categoryCarousel.scrollBy({ top: 0, left: dir * window.innerWidth / 2, behavior: 'smooth' })
    },
    onscroll (type) {
      let scroller = this.$refs.categoryCarousel
      let leftArrow = this.$refs.catLeft
      let rightArrow = this.$refs.catRight
      if(type === 'product'){
        scroller = this.$refs.productCarousel
        leftArrow = this.$refs.prodLeft
        rightArrow = this.$refs.prodRight
      } 
      const maxWidth = scroller.scrollWidth - scroller.offsetWidth
      if(scroller.scrollLeft <= 15){
        this.hideItem(leftArrow)
      } else {
        this.showItem(leftArrow)
      }
      if(scroller.scrollLeft >= maxWidth - 25){
        this.hideItem(rightArrow)
      } else {
        this.showItem(rightArrow)
      }      
    },
    sendQuick (r) {
      const quickReply = {
        text: r.title,
        next: r.next || this.message.next
      }

      if (quickReply.next === 'restart') {
        return this.$root.restart()
      }

      if (quickReply.next === 'ranking') {
        this.$parent.$parent.$emit('update:show', 'ranking')
        return this.$root.getRanking()
      }

      if (r.data) {
        quickReply.data = r.data
      } else if (r.model) {
        quickReply.data = {
          [r.model]: r
        }
      } else if (this.message.categories) {
        quickReply.data = {
          categories: this.message.categorySelection || []
        }
      }

      chat.send(quickReply)
    },
    hideItem(item) {
      // TODO: no DOM manipulation, let Vue handle this
      item.classList.add('hidden')
    },
    showItem(item){
      // TODO: no DOM manipulation, let Vue handle this
      item.classList.remove('hidden')
    }
  },
  mounted () {
    let scroller = this.$refs.categoryCarousel
    let rightArrow = this.$refs.catRight
    const maxWidth = scroller && scroller.scrollWidth - scroller.offsetWidth
    if(scroller && maxWidth === 0){
      this.hideItem(rightArrow)
    }
    if (this.message.categories) {
      const options = this.message.categories.map(c => c.key)
      this.$set(this.message, 'categorySelection', (this.$root.state.categories || []).filter(key => options.indexOf(key) > -1))
    }
  }
}
</script>

<style>
.message {
}
.message-width {
  max-width: 450px;
  margin: 0 auto;
}
.focus {
}

.msg-by-you {
  margin: 0.3em 0;
}
.msg-by-you {
  text-align: right;
}

.msg-avatar {
  display: block;
  margin-top: .5em;
  height: 80px;
  object-fit: contain;
  object-position: left;
}

/* Text message */
.msg-text {
  line-height: 1.2em;
  text-align: left;
  word-break: break-word;
  box-sizing: border-box;
}
.msg-text > p {
  line-height: 1.4em;
}
.msg-by-bot {
  margin-top: 5vh;
}
.msg-by-bot .msg-text {
  margin-top: 1em;
  padding: 0;
  color: white;
}
.msg-by-you .msg-text {
  display: inline-block;
  border-radius: 1em;
  padding: .5em 1em 0.3em;
  margin-bottom: 2em;
  background: #fff;
  color: #005ba9;
}
.rethinkable .msg-text {
  cursor: pointer;
  transition: background .2s;
}
.rethinkable .msg-text:hover {
  background-color: rgba(255, 255, 255, .7);
}
.msg-input {
  min-height: 100px;
}

.replies {
  margin: 0.5rem -0.5rem;
  transform: translateZ(0);
}
.replies-scroll {
  overflow: auto;
  margin: 0.5rem -1rem;
  padding: 0 .5rem;
  -ms-overflow-style: none;
}
.lead {
  font-size: 20px;
  line-height: 1.4em;
}

.carousel-scroll {
  position: absolute;
  top: 89px;
  font-size: 24px;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
  background: #005ba9;
  color: white;
  appearance: none;
  border: none;
  cursor: pointer;
}
.carousel-scroll-categories {
  position: absolute;
  top: 118px;
  font-size: 24px;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
  background: #005ba9;
  color: white;
  appearance: none;
  border: none;
  cursor: pointer;
}
.carousel-scroll:focus {
  outline: none;
}
.carousel-scroll-categories:focus {
  outline: none;
}
.carousel-scroll-prev {
  left: -1rem;
  border-radius: 0 99px 99px 0;
  padding: 24px 8px 24px 4px;
}
.carousel-scroll-next {
  right: -1rem;
  border-radius: 99px 0 0 99px;
  padding: 24px 4px 24px 8px;
}

.products {
  position: relative;
  font-size: 14px;
  margin-bottom: -10px;
  margin-top: 1em;
}
.product-carousel::-webkit-scrollbar { 
  display: none; 
}
.product-carousel {
  margin: -.5em -1rem;
  display: flex;
  align-items: center;
  overflow: hidden;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
  scroll-snap-type: x mandatory;
}
.categories {
  font-size: 14px;
  margin-top: 1em;
  margin-bottom: -10px;
  position: relative;
}
.category-carousel {
  margin: -.5em -1rem;
  display: flex;
  align-items: center;
  overflow: hidden;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar;
  scroll-snap-type: x mandatory;
}
.category-carousel::-webkit-scrollbar {
  display: none;
}
@media screen and (min-width: 480px) {
  .msg-by-bot .msg-text {
    padding-right: 1.5rem;
  }
}
@media screen and (min-width: 1000px) and (orientation: landscape) {
}
.slide {
  flex-shrink: 0;
  height: 100%;
  padding: 0.5rem 0.5rem 40px 0;
}
.slide:first-child {
  padding-left: 0.5rem;
}
.slide-push {
  /*width: 36px!important;*/
  scroll-snap-align: center;
}
.slide--product {
  min-height: 282px;
  width: 222px;
  width: calc(100vw / 1.5);
  scroll-snap-align: center;
}
@media screen and (min-width: 500px) {
  .slide--product {
    width: calc(100vw / 2.5);
  }
}
@media screen and (min-width: 725px) {
  .slide--product {
    width: calc(100vw / 3.5);
  }
}
/*
@media screen and (min-width: 950px) {
  .slide--product {
    width: calc(100vw / 4.5);
  }
}
@media screen and (min-width: 1175px) {
  .slide--product {
    width: calc(100vw / 5.5);
  }
}
*/
@media screen and (min-width: 925px) {
  .slide--product {
    width: calc(100vw / 4.5);
  }
}
@media screen and (min-width: 1000px) and (orientation: landscape) {
  .slide--product {
    width: calc((100vw - 350px) / 2.6);
  }
}
@media screen and (min-width: 1080px) and (orientation: landscape) {
  .slide--product {
    width: calc((100vw - 350px) / 3.5);
  }
}
@media screen and (min-width: 1300px) and (orientation: landscape) {
  .slide--product {
    width: calc((100vw - 350px) / 4.5);
  }
}
.slide--category {
  width: calc(135px / 2 + .5rem);
  height: calc(135px * 2 + 3rem);
}
.slide--category:nth-child(even) {
  position: relative;
  top: 150px;
  left: -30px;
}
.slide--category:first-child {
  margin-left: auto;
  width: calc(135px / 2 + 1rem);
}
.slide--category:last-child {
  margin-right: auto;
  width: 155px;
}
@media screen and (max-height: 568px) {
  .slide--category {
    width: calc(100px / 2 + .5rem);
    height: calc(100px * 2 + 3rem);
  }
  .slide--category:nth-child(even) {
    top: 116px;
  }
  .slide--category:first-child {
    width: calc(100px / 2 + 1rem);
  }
  .slide--category .category {
    transform: scale(0.8);
    transform-origin: top left;
  }
}

.touchStarted .carousel-scroll {
  display: none;
}
.touchStarted .carousel-scroll-categories {
  display: none;
}

.touchStarted .slide-push {
  padding: 0;
  width: 8px!important;
}
.hidden {
  display: none;
}
</style>
